import { QueryProvider } from './QueryProvider';
import { BrandingLoader } from './BrandingLoader';
import { ThemeProvider } from './ThemeProvider';
import { DeviceGate } from './DeviceGate';
import { UserLabelGate } from './UserLabelGate';

/**
 * Central providers wrapper for the application.
 * Order: QueryProvider → BrandingLoader → ThemeProvider → DeviceGate → UserLabelGate.
 */
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryProvider>
      <BrandingLoader>
        {(brandingTokens) => (
          <ThemeProvider brandingTokens={brandingTokens}>
            <DeviceGate>
              <UserLabelGate>{children}</UserLabelGate>
            </DeviceGate>
          </ThemeProvider>
        )}
      </BrandingLoader>
    </QueryProvider>
  );
}
